"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getOpenModals = exports.getState = void 0;

var getState = function getState(state) {
  return state.modal;
};

exports.getState = getState;

var getOpenModals = function getOpenModals(state) {
  var openModals = {};
  var modals = exports.getState(state);

  for (var name in modals) {
    var modal = modals[name];

    if (modal.open) {
      openModals[name] = modal;
    }
  }

  return openModals;
};

exports.getOpenModals = getOpenModals;